import * as R from 'ramda';
import { INSPECTION_ITEM_TYPE, ISSUE_PRIORITY, ISSUE_STATUS } from '@/constants';

const searchQuery = (breadcrumb) => {
    if (!breadcrumb) return null;
    const item = R.last(breadcrumb);

    if (item.type !== INSPECTION_ITEM_TYPE.CONDITIONAL) return item.title;
    return item.parent.title;
};

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        displayQuery: {
            type: Boolean,
            default: true,
        },
    },
    render(h, { props, parent, data }) {
        const priority = {
            [ISSUE_PRIORITY.LOW]: parent.$t('Low'),
            [ISSUE_PRIORITY.MEDIUM]: parent.$t('Medium'),
            [ISSUE_PRIORITY.HIGH]: parent.$t('High'),
        }[props.item.priority];

        const status = {
            [ISSUE_STATUS.OPEN]: {
                text: parent.$t('Pending'),
                badgeClass: 'badge--blue',
            },
            [ISSUE_STATUS.SOLVED]: {
                text: parent.$t('Done'),
                badgeClass: 'badge--green',
            },
            [ISSUE_STATUS.IN_PROGRESS]: {
                text: parent.$t('In progress'),
                badgeClass: 'badge--yellow',
            },
        }[props.item.status];

        const query = props.displayQuery && searchQuery(props.item.payload.breadcrumb);
        const assignees = props.item.assignees
            && Object.values(props.item.assignees).join(', ');

        const parentClass = data.class || '';

        return h('div', { class: `flex flex-col ${parentClass}` }, [
            h('div', { class: 'flex items-center mb-1' }, [
                h('span', { class: 'font-semibold' }, props.item.title),
                h('span', { class: `ml-2 badge ${status.badgeClass}` }, status.text),
            ]),

            props.item.due_at
            && h('span', { class: 'mb-1' }, `${parent.$t('Deadline')}: ${parent.$du(
                props.item.due_at,
                'shortDateTime',
            )}`),

            assignees
            && h('span', { class: 'mb-1' }, `${parent.$t('Assignee')}: ${assignees}`),

            h('span', { class: 'mb-1' }, `${parent.$t('Priority')}: ${priority}`),
            query && h('span', `${parent.$t('Query')}: ${query}`),
        ]);
    },
};
